<!-- eslint-disable vue/singleline-html-element-content-newline -->
<!-- eslint-disable no-use-before-define -->
<!-- eslint-disable one-var -->
<!--高德地图位置选择组件-->
<template>
  <el-dialog
    v-model="dialogVisible"
    title="请选择位置"
    width="80%"
    top="5vh"
    :close-on-click-modal="true"
  >
    <div>
      <!-- 搜索框（可选，可后续加） -->
      <!-- <div style="margin-bottom: 10px">
        <el-input
          v-model="searchKeyword"
          placeholder="搜索地点（可选）"
          style="width: 300px; margin-right: 8px"
          @keyup.enter="searchPlace"
        />
        <el-button type="primary" @click="searchPlace"> 搜索 </el-button>
        <el-button @click="getCurrentLocation"> 当前位置 </el-button>
      </div> -->

      <!-- 高德地图容器 -->
      <div
        id="address"
        style="width: 100%; height: 700px; border: 1px solid #ddd"
      ></div>

      <!-- 当前选中的位置信息（可选展示） -->
      <div
        v-if="selectedLocation"
        style="
          margin-top: 15px;
          padding: 10px;
          background: #f0f0f0;
          border-radius: 4px;
          display: flex;
        "
      >
        <p><strong>当前选中：</strong></p>
        <p>{{ selectedLocation.position }}</p>
        <p style="margin-left: 10px">经度：{{ selectedLocation.longitude }}</p>
        <p style="margin-left: 10px">纬度：{{ selectedLocation.latitude }}</p>
      </div>
    </div>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="confirm">确定</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, watch, onUnmounted } from 'vue';
import AMapLoader from '@amap/amap-jsapi-loader';
import { ElNotification } from 'element-plus';

// =========================
// 1. Props & Emits
// =========================

// v-model:visible
const props = defineProps({
    visible: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: Object,
      default: null // 外部可以传入 { address, lng, lat } 或 { name, address, longitude, latitude }
    }
  }),
  emit = defineEmits(['update:visible', 'update:modelValue', 'confirm']),
  // v-model 双向绑定
  dialogVisible = ref(props.visible);

// 监听外部 visible 变化
watch(
  () => props.visible,
  (val) => {
    dialogVisible.value = val;
  }
);

// 监听 dialogVisible 变化，同步到外部
watch(dialogVisible, async (val) => {
  emit('update:visible', val);
  if (val) {
    // 弹窗打开了，初始化地图
    // eslint-disable-next-line no-use-before-define
    await initMap();
    // 地图初始化完成后，立即获取当前位置
    setTimeout(() => {
      // eslint-disable-next-line no-use-before-define
      getCurrentLocation();
    }, 500); // 稍微延迟确保地图完全加载
  }
});

// =========================
// 2. 地图相关变量
// =========================

let map = null, //地图实例
  loca = null, // 高德数据可视化实例 Loca（Loca API 2.0）
  marker = null,
  geocoder = null,
  placeSearch = null;

// eslint-disable-next-line newline-after-var, one-var
const searchKeyword = ref(''),
  selectedLocation = ref(null), // 当前选中的位置，最终会通过 confirm 返回
  // =========================
  // 3. 初始化地图
  // =========================
  //地图初始化
  initMap = async () => {
    // eslint-disable-next-line no-underscore-dangle
    window._AMapSecurityConfig = {
      securityJsCode: '81923c81ddb0a9f7b0f57f80e95c4c19'
    };

    try {
      const AMap = await AMapLoader.load({
        key: '03f216b18186b1ddde56d02389b28c79', // 申请好的Web端开发者Key，首次调用 load 时必填
        version: '2.0', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [
          'AMap.Geocoder', // 添加地理编码插件
          'AMap.Scale',
          'AMap.ToolBar',
          'AMap.ElasticMarker',
          'AMap.DistrictSearch'
        ], //需要使用的的插件列表，如比例尺'AMap.Scale'，支持添加多个如：['...','...']
        Loca: {
          // 是否加载 Loca， 缺省不加载
          version: '2.0.0' // Loca 版本，缺省 1.3.2
        }
      });

      // 初始化地理编码器
      geocoder = new AMap.Geocoder({
        radius: 1000,
        extensions: 'all'
      });

      //获取丘北县地理信息
      // eslint-disable-next-line one-var
      const district = new AMap.DistrictSearch({
        subdistrict: 3, // 0：不返回下级行政区 1：返回下一级行政区 2：返回下两级行政区 3：返回下三级行政区
        extensions: 'all', //默认值：base，不返回行政区边界坐标点，取值：all，返回完整行政区边界坐标点
        level: 'country' //country：国家 province：省/直辖市 city：市 district：区/县 biz_area：商圈
      });

      return new Promise((resolve) => {
        district.search('中国', function (status, result) {
          const bounds = result.districtList[0].boundaries,
            mask = [];

          for (let i = 0; i < bounds.length; i++) {
            mask.push([bounds[i]]);
          }

          map = new AMap.Map('address', {
            // // 设置地图容器id
            mask: mask, // 为Map实例制定掩模的路径,各图层将值显示路径范围内图像,3D模式下有效
            expandZoomRange: true, // 开启显示范围设置
            pitch: 42, //地图俯仰角度，有效范围 0 度- 83 度
            viewMode: '3D', // 是否为3D地图模式
            terrain: true, //开启地形图
            zoom: 5, // 初始化地图级别
            center: [108.940174, 34.341568], // 初始化地图中心点位置
            mapStyle: 'amap://styles/blue' //设置地图的显示样式
          });

          // 添加描边
          for (let i = 0; i < bounds.length; i++) {
            const polyline = new AMap.Polyline({
              path: bounds[i], // polyline 路径，支持 lineString 和 MultiLineString
              strokeColor: '#3078AC', // 线条颜色，使用16进制颜色代码赋值。默认值为#00D3FC
              strokeWeight: 2 // 轮廓线宽度,默认为:2
            });

            polyline.setMap(map);
          }

          // 添加地图点击事件
          // eslint-disable-next-line no-use-before-define
          map.on('click', handleMapClick);

          //缩放工具条实例化
          // eslint-disable-next-line one-var
          const toolbar = new AMap.ToolBar();

          map.addControl(toolbar);
          //比例尺工具条实例化
          // eslint-disable-next-line one-var
          const Scale = new AMap.Scale();

          map.addControl(Scale);

          resolve();
        });
      });
    } catch (e) {
      console.log(e);
    }
  },
  // =========================
  // 4. 定位到外部传入的位置
  // =========================

  locateToExternalLocation = (loc) => {
    let lng = 0,
      lat = 0,
      address = '';

    // 支持多种传入格式，比如 { lng: 116.404, lat: 39.915 } 或 { longitude: ..., latitude: ... }
    if (typeof loc.lng === 'number' || typeof loc.lng === 'string') {
      lng = parseFloat(loc.lng);
      lat = parseFloat(loc.lat);
    } else if (
      typeof loc.longitude === 'number' ||
      typeof loc.longitude === 'string'
    ) {
      lng = parseFloat(loc.longitude);
      lat = parseFloat(loc.latitude);
    }

    if (isNaN(lng) || isNaN(lat)) {
      console.warn('外部传入的位置经纬度格式不正确', loc);
      // eslint-disable-next-line no-use-before-define
      getCurrentLocation();
      return;
    }

    const pos = [lng, lat];

    map.setCenter(pos);
    map.setZoom(16);

    // 如果有地址就显示，否则尝试逆地理编码
    if (loc.address) {
      address = loc.address;
    } else {
      // 逆地址解析
      geocoder.getAddress(pos, (status, result) => {
        if (status === 'complete' && result.regeocode) {
          address = result.regeocode.formattedAddress;
        } else {
          address = '地址解析失败';
        }
      });
    }

    selectedLocation.value = {
      name: loc.name || '传入位置',
      address: address,
      lng: lng.toFixed(6),
      lat: lat.toFixed(6),
      longitude: lng,
      latitude: lat,
      position: address
    };

    // eslint-disable-next-line no-use-before-define
    addMarker(pos, selectedLocation.value.name, selectedLocation.value.address);
  },
  // =========================
  // 5. 获取当前用户位置
  // =========================
  getCurrentLocation = () => {
    if (!navigator.geolocation) {
      // eslint-disable-next-line new-cap
      ElNotification({
        message: '浏览器不支持定位，将显示默认位置',
        type: 'warning',
        duration: 2000
      });
      // 默认北京
      const pos = [116.397428, 39.90923];

      map.setCenter(pos);
      map.setZoom(16);
      // eslint-disable-next-line one-var
      const loc = {
        name: '当前位置',
        address: '当前浏览器不支持定位，显示默认位置',
        lng: pos[0].toFixed(6),
        lat: pos[1].toFixed(6),
        longitude: pos[0],
        latitude: pos[1],
        position: '当前浏览器不支持定位，显示默认位置'
      };

      selectedLocation.value = loc;
      // eslint-disable-next-line no-use-before-define
      addMarker(pos, loc.name, loc.address);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { longitude, latitude } = position.coords,
          pos = [longitude, latitude];

        map.setCenter(pos);
        map.setZoom(16);

        if (geocoder) {
          geocoder.getAddress(pos, (status, result) => {
            if (status === 'complete' && result.regeocode) {
              const addr = result.regeocode.formattedAddress,
                loc = {
                  name: '当前位置',
                  address: addr,
                  lng: longitude.toFixed(6),
                  lat: latitude.toFixed(6),
                  longitude,
                  latitude,
                  position: addr
                };

              selectedLocation.value = loc;
              // eslint-disable-next-line no-use-before-define
              addMarker(pos, loc.name, loc.address);
            } else {
              const loc = {
                name: '当前位置',
                address: '地址解析失败',
                lng: longitude.toFixed(6),
                lat: latitude.toFixed(6),
                longitude,
                latitude,
                position: '地址解析失败'
              };

              selectedLocation.value = loc;
              // eslint-disable-next-line no-use-before-define
              addMarker(pos, loc.name, loc.address);
            }
          });
        }
      },
      (error) => {
        console.error('定位错误:', error);
        alert('定位失败，显示默认位置');
        const pos = [116.397428, 39.90923];

        map.setCenter(pos);
        map.setZoom(16);
        // eslint-disable-next-line one-var
        const loc = {
          name: '当前位置',
          address: '定位失败，显示默认位置',
          lng: pos[0].toFixed(6),
          lat: pos[1].toFixed(6),
          longitude: pos[0],
          latitude: pos[1],
          position: '定位失败，显示默认位置'
        };

        selectedLocation.value = loc;
        // eslint-disable-next-line no-use-before-define
        addMarker(pos, loc.name, loc.address);
      }
    );
  },
  // =========================
  // 6. 地图点击 -> 获取地址
  // =========================

  handleMapClick = (e) => {
    const { lng, lat } = e.lnglat,
      pos = [lng, lat];

    if (geocoder) {
      geocoder.getAddress(pos, (status, result) => {
        if (status === 'complete' && result.regeocode) {
          const addr = result.regeocode.formattedAddress,
            loc = {
              name: '点击位置',
              address: addr,
              lng: lng.toFixed(6),
              lat: lat.toFixed(6),
              longitude: lng,
              latitude: lat,
              position: addr
            };

          selectedLocation.value = loc;
          // eslint-disable-next-line no-use-before-define
          addMarker(pos, loc.name, loc.address);
        } else {
          const loc = {
            name: '点击位置',
            address: '地址解析失败',
            lng: lng.toFixed(6),
            lat: lat.toFixed(6),
            longitude: lng,
            latitude: lat,
            position: '地址解析失败'
          };

          selectedLocation.value = loc;
          // eslint-disable-next-line no-use-before-define
          addMarker(pos, loc.name, loc.address);
        }
      });
    }
  },
  // =========================
  // 7. 添加标记
  // =========================

  addMarker = (position, name, address) => {
    if (marker) {
      map.remove(marker);
    }
    marker = new window.AMap.Marker({
      position,
      title: name,
      icon: new window.AMap.Icon({
        size: new window.AMap.Size(32, 32),
        image: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png',
        imageSize: new window.AMap.Size(32, 32)
      })
    });
    map.add(marker);
  },
  // =========================
  // 8. 搜索（可选，可完善）
  // =========================

  searchPlace = () => {
    if (!searchKeyword.value.trim()) {
      return;
    }
    // 可以后续接入 placeSearch.search(...)
  },
  // =========================
  // 9. 弹窗按钮事件
  // =========================

  cancel = () => {
    emit('update:visible', false);
  },
  confirm = () => {
    if (selectedLocation.value) {
      emit('confirm', selectedLocation.value); // 返回选中的位置信息
    }
    emit('update:visible', false);
  };

// 监听外部传入的 modelValue 变化
watch(
  () => props.modelValue,
  (newVal) => {
    if (newVal && map) {
      locateToExternalLocation(newVal);
    }
  },
  { immediate: true }
);

onUnmounted(() => {
  if (map) {
    map.off('click', handleMapClick);
    map.destroy();
  }
});
</script>

<style scoped>
.el-dialog__footer {
  margin-left: 64%;
}
</style>
